import React, { useEffect, useState } from 'react'
// import Button from "../button";
import styles from './embassies_modal.module.css'
import { student } from '../../store/student'
import { report } from '../../store/report'
import http from '../../Service/http'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { toast } from 'react-toastify'

const AboutLearningModalKGMA = ({ openForm, openSpravka }) => {
	const { t, i18n } = useTranslation()
	const [modalData, setModalData] = useState([])
	const [refusal, setRefusal] = useState(false)
	const [isSave, setIsSave] = useState(false)
	const [updateData, setUpdateData] = useState({
		naznachenie: '',
		naznachenie_kg: '',
	})
	const [reasonRefusal, setReasonRefusal] = useState({
		rejected_komment: ''
	})

	const day_do = new Date().getDay()
	const month_do = new Date().getMonth() + 1;
	const year_do = new Date().getFullYear() 

	const [updateDataDo, setUpdateDataDo] = useState({
		data_po: `${year_do}-${month_do}-${day_do}`,
	})


	const change = e => {
		const { name, value } = e.target
		setUpdateData({ ...updateData, [name]: value })
		console.log(':nameval', { [name]: value })
		setIsSave(true)
		console.log('issave', isSave)
	}

	const onChangeDate = e => {
		setUpdateDataDo({
			...updateDataDo,
			[e.target.name]: e.target.name == 'with_honors' ? e.target.checked : e.target.value
		})
		setIsSave(true)
	}

	const changeRefusal = e => {
		const { name, value } = e.target
		setReasonRefusal({ ...reasonRefusal, [name]: value })
		console.log(':reasonRefusal', { [name]: value })
	}

	const getReports = async id => {
		const a = await http.post('/report/reportApplicationWait?reportType=' + id)
		report.newReport(a.data.reportApplicationWait)
	}

	const openInput = () => {
		setRefusal(!refusal)
	}

	useEffect(() => {
		getReports(0)
	}, [])
	useEffect(() => {
		if (openForm) {
			getModaldata()
		}
	}, [])

	const getModaldata = async () => {
		const res = await http.post('/okno/modaldata', {
			uid: student.student.id_student,
			gid: student.student.id_group,
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document
			// naznachenie: student.student.naznachenie,
		})
		setModalData(res.data.data)
		setUpdateData({
			naznachenie: res.data.data.naznachenie,
			naznachenie_kg: res.data.data.naznachenie_kg
		})
		setUpdateDataDo({data_po:dayjs(res.data.data.data_po).format("YYYY-MM-DD")})

		// console.log("modal", modalData);
	}

	React.useEffect(() => {
		document.body.style.overflowY = 'hidden'
		return () => (document.body.style.overflowY = 'visible')
	}, [])

	const updateModalDate = async () => {
		const data_po = dayjs(updateDataDo.data_po).format('YYYY-MM-DD HH:mm:ss')

		const res = await http.post('/okno/modalDateUpdate', {
			id_zakaz: student.student.id_okno_zakaz,
			uid: student.student.id_student,
			gid: student.student.id_group,
			doc: student.student.id_okno_document,
			naznachenie: updateData.naznachenie,
			naznachenie_kg: updateData.naznachenie_kg,
			surname: null,
			raion_kg: null,
			practice: false,
			cause: null,
			data_c: null,
			data_po: data_po,
			data_c_os: null,
			data_po_os: null,
			data_c_vs: null,
			data_po_vs: null,
			data_c_prictice: null,
			data_po_practice: null,
			data_c_holidays: null,
			data_po_holidays: null,
			work: null
		})
		if (res.data.result !== null) {
			toast(res.data.result)
			setIsSave(false)
		}
		// console.log("update", res);
	}

	const postReasonRefusal = async () => {
		const res = await http.post('/okno/reasonRefusal', {
			id_zakaz: student.student.id_okno_zakaz,
			doc: student.student.id_okno_document,
			rejected_komment: reasonRefusal.rejected_komment
		})
		if (res.data.result == null) {
			toast(res.data.result)
			getReports(0)
			openForm()
			// setIsSave(false)
		}
		// console.log("update", res);
	}

	return (
		<div className={styles.modal}>
			<div className={styles.modal_window}>
				<div className={styles.modal_window_head}>
					<div></div>
					<label>{modalData?.okno_document}</label>
					{!refusal ? (
						<div className={styles.add_form_stud_exit}>
							{updateData.naznachenie?.length > 6 ? (
								<button className={styles.button_modal}>
										<a
											onClick={openForm}
											className='new_report'
											target='_blank'
											href={`/bt/api/r/s-s?idzakaz=${student.student.id_okno_zakaz}&idf=${student.student.id_faculty}&gid=${student.student.id_group}&id=${student.student.id_student}&lang=${i18n.language}`}
										>
											{' '}
											Просмотр
										</a>
								</button>
							) : null}
						</div>
					) : (
						<div></div>
					)}
				</div>

				{!refusal ? (
					<div>
						<div className={styles.name_student}>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Студент:</span>
								<p>{modalData?.fio}</p>
							</div>
							<div className={styles.name_student_block}>
								<span className={styles.name_student_text}>Уникальный номер справки:</span>
								<p>{modalData?.reference_number}</p>
							</div>
						</div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Максаты:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='naznachenie_kg'
									value={updateData.naznachenie_kg}
									onChange={change}
								>
									{/* Назначение */}
								</input>
							</div>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Назначение:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='naznachenie'
									value={updateData.naznachenie}
									onChange={change}
								>
									{/* Назначение */}
								</input>
							</div>


							<div className={styles.input_block}>
								<div className={styles.new_input_block_date}>
									<span className={styles.name_student_text}>Действительна до:</span>
								</div>
								<div className={styles.new_input_block_date2} style={{marginLeft: '30px'}}>
									<input
										onChange={onChangeDate}
										className={styles.input_modal_date}
										type='date'
										placeholder='дата'
										name='data_po'
										value={updateDataDo.data_po}
									/>
									<span className={styles.name_student_text}>чейин жарактуу</span>
								</div>
							</div>
						</div>

						<div className={styles.user}>
							<div className={styles.user_name}>
								<span className={styles.name_student_text}>Исполнитель:</span>
								<p>{modalData?.AVN_operator}</p>
							</div>
						</div>
					</div>
				) : (
					<div>
						<div className={styles.modal_window_data}>
							<div className={styles.input_block}>
								<span className={styles.name_student_text}>Причина отказа:</span>
								<input
									className={styles.input_modal}
									type='text'
									name='rejected_komment'
									placeholder='Введите причину отказа...'
									value={reasonRefusal.rejected_komment}
									onChange={changeRefusal}
								>
									{/* Причина отказа */}
								</input>
							</div>
						</div>
					</div>
				)}
				<div className={styles.modal_footer}>
					<div></div>
					<div className={styles.footer_buttons}>
						{refusal ? (
							<>
								{reasonRefusal.rejected_komment?.length >= 6 ? (
									<button onClick={postReasonRefusal} className={styles.button_modal}>
										Отказать
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={postReasonRefusal}
									>
										Отказать
									</button>
								)}
								<button onClick={openInput} className={styles.button_modal}>
									Назад
								</button>
							</>
						) : (
							<>
								<button onClick={openInput} className={styles.button_modal}>
									Отказать
								</button>
								{updateData.naznachenie?.length >= 3 && isSave ? (
									<button className={styles.button_modal} onClick={updateModalDate}>
										Сохранить
									</button>
								) : (
									<button
										className={styles.button_modal}
										style={{ background: '#c8c8c8' }}
										disabled
										onClick={updateModalDate}
									>
										Сохранить
									</button>
								)}
								<button onClick={openForm} className={styles.button_modal}>
									Закрыть
								</button>
							</>
						)}
					</div>
				</div>
			</div>
		</div>
	)
}

export default AboutLearningModalKGMA
